import React from 'react'

const Footer = () => {
  return (
    <footer className="footer">
      <div className="col-12 flexbox">
        <div className="col-md-6">
          <div className="nav nav-left">
          </div>
        </div>
        <div className="col-md-6 text-right">
          <a className="nav-link" href="#"><small>Assured Disposal by Earth Ideal ©2021</small></a>
        </div>
      </div>

    </footer>

  )
}

export default Footer
